/**
 * @hidden
 */
export var firefox = typeof window !== 'undefined' && /Firefox/.test(window.navigator.userAgent);